<template>
  <v-dialog v-model="show" max-width="1500px" persistent>
    <v-card>
      <v-card-title>
        Nuevo Movimiento - {{ step === 1 ? 'Recepción inicial' : 'Agregar artículo' }}
        <v-spacer></v-spacer>
      </v-card-title> 
      
      <!-- STEP 1 -->
      <v-card-text v-if="step === 1">
        <v-alert
          v-if="validationErrors.length > 0"
          type="error"
          outlined
          dense
          class="mb-4"
        >
          <div class="font-weight-medium mb-1">Faltan datos requeridos:</div>
          <div v-for="(error, idx) in validationErrors" :key="`err-step1-${idx}`">- {{ error }}</div>
        </v-alert>
        <v-row>
          <v-col cols="3">
            <v-autocomplete
              v-model="step1.idAlmacen"
              label="Almacén"
              :items="almacenes"
              :item-text="almacenText"
              item-value="idAlmacen"
              :loading="loadingAlmacenes"
              clearable
              @change="changeAlmacen"
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="step1.tipoAlmacen"
              label="Tipo almacén"
              :items="tiposAlmacenDisponibles"
              item-text="text"
              item-value="value"
              :clearable="false"
              :disabled="tipoAlmacenBloqueado"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              v-model="step1.idArea"
              label="Área"
              :items="areas"
              :item-text="areaText"
              item-value="idArea"
              :loading="loadingAreas"
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col cols="3"><v-select v-model="step1.tipoMovimiento" label="Tipo de Movimiento" :items="['Entrada']" clearable></v-select></v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-autocomplete
              v-model="step1.idSubalmacen"
              label="Subalmacén"
              :items="subalmacenesComputed"
              :item-text="subalmacenText"
              item-value="idSubalmacen"
              :loading="loadingSubalmacenes"
              :disabled="!step1.idAlmacen || loadingSubalmacenes"
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col cols="4">
             <v-text-field type="datetime-local" v-model="step1.fechaRecepcion" label="Fecha de Recepción"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-select
              v-model="step1.tipoCalidad"
              label="Tipo de Calidad"
              :items="tiposCalidad"
              clearable
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
             <v-text-field type="date" v-model="step1.fechaArribo" label="Fecha Arribo"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              v-model="step1.idCliente"
              label="Cliente"
              :items="clientes"
              :item-text="clienteText"
              item-value="idCliente"
              :loading="loadingClientes"
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col cols="4"><v-text-field v-model="step1.tipoSolicitud" label="Tipo solicitud"></v-text-field></v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-autocomplete
              v-model="step1.idTurno"
              label="Turno"
              :items="turnos"
              :item-text="turnoText"
              item-value="idTurno"
              :loading="loadingTurnos"
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col cols="4"><v-text-field v-model="step1.numeroCortina" label="Número de cortina"></v-text-field></v-col>
          <v-col cols="4"><v-text-field v-model="step1.operador" label="Operador"></v-text-field></v-col>
        </v-row>
        <v-row>
          <v-col cols="4"><v-text-field v-model="step1.montacarguista" label="Montacarguista"></v-text-field></v-col>
          <v-col cols="4"><v-text-field v-model="step1.placas" label="Número de placas"></v-text-field></v-col>
          <v-col cols="4"><v-text-field v-model="step1.sello" label="Número de sello"></v-text-field></v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
             <v-text-field type="time" v-model="step1.horaFin" label="Hora fin"></v-text-field>
          </v-col>
          <v-col cols="4"><v-text-field v-model="step1.lineaTransporte" label="Línea de transporte"></v-text-field></v-col>
        </v-row>

        <div class="text-center mt-5 mb-3"><h3>Proveedores</h3></div>
        
        <v-data-table
          :headers="[
            { text: 'Proveedor', value: 'proveedor', align: 'center', width: '80%' },
            { text: 'Acciones', value: 'actions', align: 'center', sortable: false, width: '20%' }
          ]"
          :items="proveedores"
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:[`item.proveedor`]="{ item }">
            <v-autocomplete
              v-model="item.idProveedor"
              :items="listaProveedores"
              :item-text="proveedorLabel"
              item-value="idProveedor"
              :loading="loadingProveedores"
              dense
              hide-details
              clearable
            ></v-autocomplete>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom color="black">
              <template v-slot:activator="{ on }">
                <v-icon small v-on="on" @click="eliminarProveedor(item)">mdi-delete</v-icon>
              </template>
              <span class="white--text">Eliminar</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <v-btn text color="primary" class="mt-3" @click="agregarProveedor">Agregar Proveedor</v-btn>
      </v-card-text>

      <!-- STEP 2 -->
      <v-card-text v-if="step === 2">
        <v-alert
          v-if="validationErrors.length > 0"
          type="error"
          outlined
          dense
          class="mb-4"
        >
          <div class="font-weight-medium mb-1">No se puede continuar:</div>
          <div v-for="(error, idx) in validationErrors" :key="`err-step2-${idx}`">- {{ error }}</div>
        </v-alert>
        <v-row>
          <v-col cols="6">
            <v-autocomplete
              v-model="artInput.idArticulo"
              label="Artículo"
              :items="articulosCatalogo"
              :item-text="articuloLabel"
              item-value="idArticulo"
              :loading="loadingArticulos"
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col cols="6"><v-textarea v-model="artInput.descripcionArticulo" label="Descripción" rows="1" auto-grow maxlength="110" counter="110"></v-textarea></v-col>
        </v-row>

        <div class="text-center mt-5 mb-3"><h3>Elementos (Etiquetas)</h3></div>

        <v-data-table
          :headers="[
            { text: 'Número de Envases', value: 'envases', align: 'center', width: '25%' },
            { text: 'Volumen del Envase', value: 'volumen', align: 'center', width: '25%' },
            { text: '[Opcional] Folio', value: 'folio', align: 'center', width: '20%' },
            { text: 'Fecha de caducidad', value: 'caducidad', align: 'center', width: '20%' },
            { text: '[Opcional] Lote', value: 'lote', align: 'center', width: '20%' },
            { text: 'Acciones', value: 'actions', align: 'center', width: '10%' }
          ]"
          :items="etiquetasBuffer"
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:[`item.envases`]="{ item }">
            <v-text-field
              v-model.number="item.envases"
              type="number"
              min="1"
              step="1"
              dense
              hide-details
              @blur="ensureMinOne(item, 'envases', true)"
            ></v-text-field>
          </template>
          <template v-slot:[`item.volumen`]="{ item }">
            <v-text-field
              v-model.number="item.volumen"
              type="number"
              min="1"
              step="any"
              dense
              hide-details
              @blur="ensureMinOne(item, 'volumen')"
            ></v-text-field>
          </template>
          <template v-slot:[`item.folio`]="{ item }">
            <v-text-field v-model="item.folio" placeholder="[Opcional] Folio" dense hide-details></v-text-field>
          </template>
          <template v-slot:[`item.caducidad`]="{ item }">
            <v-text-field v-model="item.caducidad" type="date" dense hide-details></v-text-field>
          </template>
          <template v-slot:[`item.lote`]="{ item }">
            <v-text-field v-model="item.lote" placeholder="[Opcional] Lote" dense hide-details></v-text-field>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom color="black">
              <template v-slot:activator="{ on }">
                <v-icon small v-on="on" @click="eliminarEtiquetaBuffer(item)">mdi-delete</v-icon>
              </template>
              <span class="white--text">Eliminar</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <v-btn text color="primary" class="mt-3" @click="agregarEtiqueta">Agregar Elemento (Etiqueta)</v-btn>

        <div class="mt-4 mb-4 d-flex justify-end">
          <v-btn color="primary" outlined @click="agregarArticulo">Guardar Artículo Actual</v-btn>
        </div>

        <div class="text-center mt-5 mb-3"><h3>Artículos Guardados</h3></div>
        
        <v-data-table
          :headers="[
            { text: 'Cantidad', value: 'cantidad', align: 'center', width: '10%' },
            { text: 'Artículo', value: 'nombre', align: 'center' },
            { text: 'Descripción', value: 'descripcion', align: 'center' },
            { text: 'Desglosar', value: 'data-table-expand', align: 'center', width: '10%' },
            { text: 'Acciones', value: 'acciones', align: 'center', width: '10%' }
          ]"
          :items="articulos"
          hide-default-footer
          :items-per-page="-1"
          show-expand
          :expanded.sync="expandedArts"
          item-key="uuid"
        >
          <template v-slot:[`item.cantidad`]="{ item }">
            {{ articuloCantidad(item) }}
          </template>
          <template v-slot:[`item.data-table-expand`]="{ item, isExpanded, expand }">
            <v-tooltip v-if="item.etiquetas.length > 0" bottom color="black" class="white--text text-center">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" @click="expand(!isExpanded)">{{ isExpanded ? 'mdi-close' : 'mdi-chevron-down' }}</v-icon>
              </template>
              <span class="white--text">{{ isExpanded ? 'Contraer' : 'Expandir (Ver etiquetas)' }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.acciones`]="{ item }">
            <v-icon small color="red" @click="eliminarArticulo(item)">mdi-delete</v-icon>
          </template>
          
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="px-4" style="background-color: white !important">
              <h4 class="text--secondary text-center mb-1 mt-2" style="font-size: 16px;">Etiquetas del artículo</h4>
              <v-data-table
                :headers="[{text: '# Envases', value:'envases', align:'center'}, {text: 'Volumen', align:'center', value:'volumen'}, {text:'Folio', value:'folio', align:'center'}, {text:'Caducidad', value:'caducidad', align:'center'}, {text:'Lote', value:'lote', align:'center'}, {text:'Quitar', value:'acciones', align:'center'}]"
                :items="item.etiquetas"
                hide-default-footer
                :items-per-page="-1"
              >
                <template v-slot:[`item.acciones`]="{ item: eItem }">
                  <v-icon small color="red" @click="eliminarEtiquetaDeArticulo(item, eItem)">mdi-delete</v-icon>
                </template>
              </v-data-table>
            </td>
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="step === 2" color="grey" text @click="step = 1" class="hide-print" :disabled="savingRecepcion">Regresar</v-btn>
        <v-btn v-if="step === 1" color="green" text @click="close(0)" class="hide-print" :disabled="savingRecepcion">Cancelar</v-btn>
        <v-btn color="red darken-1" text @click="nextStep" class="hide-print" :loading="savingRecepcion" :disabled="savingRecepcion">{{ step === 2 ? 'Guardar' : 'Siguiente' }}</v-btn>
      </v-card-actions>

      <v-snackbar
        v-model="showValidationSnackbar"
        color="error"
        bottom
        right
        timeout="6500"
        multi-line
      >
        <div>{{ validationSnackbarText }}</div>
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="showValidationSnackbar = false">Cerrar</v-btn>
        </template>
      </v-snackbar>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";

const pad2 = value => String(value).padStart(2, "0");
const formatDate = date => `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
const formatTime = date => `${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
const formatDateTimeLocal = date => `${formatDate(date)}T${formatTime(date)}`;

const createStep1Defaults = () => {
  const now = new Date();
  return {
    idAlmacen: null,
    tipoAlmacen: "",
    idArea: null,
    idSubalmacen: null,
    tipoMovimiento: "Entrada",
    fechaRecepcion: formatDateTimeLocal(now),
    tipoCalidad: "Alta",
    fechaArribo: formatDate(now),
    idCliente: null,
    tipoSolicitud: "",
    idTurno: null,
    numeroCortina: "",
    operador: "",
    montacarguista: "",
    placas: "",
    sello: "",
    horaFin: formatTime(now),
    lineaTransporte: ""
  };
};

const createEtiquetaDefault = () => ({
  envases: 1,
  volumen: 1,
  folio: "",
  caducidad: formatDate(new Date()),
  lote: "",
  uuid: 0
});

export default {
  name: "WizardNuevoMovimientoLogi",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      step: 1,
      proveedorDefault: { idProveedor: null, uuid: 0 },
      etiquetaDefault: createEtiquetaDefault(),
      almacenes: [],
      areas: [],
      subalmacenes: [],
      clientes: [],
      turnos: [],
      articulosTipos: [],
      articulosLista: [],
      articulosCatalogo: [],
      listaProveedores: [],
      loadingAlmacenes: false,
      loadingAreas: false,
      loadingSubalmacenes: false,
      loadingClientes: false,
      loadingTurnos: false,
      loadingArticulos: false,
      loadingProveedores: false,
      tiposAlmacen: [
        { text: "General", value: "GENERAL" },
        { text: "Aduana", value: "ADUANA" },
        { text: "Merma", value: "MERMA" }
      ],
      tiposCalidad: ["Alta", "Media", "Baja"],
      // Step 1 Data
      step1: createStep1Defaults(),
      proveedores: [],
      
      // Step 2 Data
      artInput: {
        idArticulo: null,
        descripcionArticulo: ''
      },
      etiquetasBuffer: [],
      articulos: [],
      expandedArts: [],
      validationErrors: [],
      showValidationSnackbar: false,
      savingRecepcion: false,
      
      uuidCounter: 1
    };
  },
  computed: {
    subalmacenesComputed() {
      if (!this.step1.idAlmacen) return [];
      return this.subalmacenes.filter(subalmacen => subalmacen.idAlmacen === this.step1.idAlmacen);
    },
    almacenSeleccionado() {
      return this.almacenes.find(almacen => almacen.idAlmacen === this.step1.idAlmacen) || null;
    },
    areaSeleccionada() {
      return this.areas.find(area => area.idArea === this.step1.idArea) || null;
    },
    clienteSeleccionado() {
      return this.clientes.find(cliente => cliente.idCliente === this.step1.idCliente) || null;
    },
    turnoSeleccionado() {
      return this.turnos.find(turno => turno.idTurno === this.step1.idTurno) || null;
    },
    subalmacenSeleccionado() {
      return this.subalmacenesComputed.find(subalmacen => subalmacen.idSubalmacen === this.step1.idSubalmacen) || null;
    },
    validationSnackbarText() {
      if (!this.validationErrors.length) return "";
      if (this.validationErrors.length === 1) return this.validationErrors[0];
      return `${this.validationErrors[0]} (+${this.validationErrors.length - 1} más)`;
    },
    tipoAlmacenPermitido() {
      if (!this.step1.idAlmacen) return "";
      const almacen = this.almacenes.find(item => String(item.idAlmacen) === String(this.step1.idAlmacen));
      return this.normalizarTipoAlmacen(almacen ? (almacen.tipoAlmacen || almacen.TipoAlmacen) : "") || "GENERAL";
    },
    tiposAlmacenDisponibles() {
      if (!this.step1.idAlmacen) return this.tiposAlmacen;
      return this.tiposAlmacen.filter(tipo => tipo.value === this.tipoAlmacenPermitido);
    },
    tipoAlmacenBloqueado() {
      return !this.step1.idAlmacen;
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.reset();
        this.loadCatalogos();
      }
    },
    "step1.idAlmacen"(value) {
      this.syncTipoAlmacenFromSelection(value);
    },
    "step1.tipoAlmacen"(value) {
      if (!this.step1.idAlmacen) return;
      if (value !== this.tipoAlmacenPermitido) {
        this.step1.tipoAlmacen = this.tipoAlmacenPermitido;
      }
    },
    almacenes() {
      this.syncTipoAlmacenFromSelection(this.step1.idAlmacen);
    },
    step() {
      this.validationErrors = [];
      this.showValidationSnackbar = false;
    }
  },
  methods: {
    isEmpty(value) {
      if (value === null || value === undefined) return true;
      if (typeof value === "string") return value.trim() === "";
      if (Array.isArray(value)) return value.length === 0;
      return false;
    },
    validateStep1() {
      const requiredFields = [
        { key: "idAlmacen", label: "Almacén" },
        { key: "tipoAlmacen", label: "Tipo almacén" },
        { key: "idArea", label: "Área" },
        { key: "tipoMovimiento", label: "Tipo de Movimiento" },
        { key: "idSubalmacen", label: "Subalmacén" },
        { key: "fechaRecepcion", label: "Fecha de Recepción" },
        { key: "tipoCalidad", label: "Tipo de Calidad" },
        { key: "fechaArribo", label: "Fecha Arribo" },
        { key: "idCliente", label: "Cliente" },
        { key: "tipoSolicitud", label: "Tipo solicitud" },
        { key: "idTurno", label: "Turno" },
        { key: "numeroCortina", label: "Número de cortina" },
        { key: "operador", label: "Operador" },
        { key: "montacarguista", label: "Montacarguista" },
        { key: "placas", label: "Número de placas" },
        { key: "sello", label: "Número de sello" },
        { key: "horaFin", label: "Hora fin" },
        { key: "lineaTransporte", label: "Línea de transporte" }
      ];

      const missing = requiredFields
        .filter(field => this.isEmpty(this.step1[field.key]))
        .map(field => field.label);

      if (this.proveedores.length === 0) {
        missing.push("Agrega al menos un proveedor");
      } else {
        this.proveedores.forEach((proveedor, idx) => {
          if (this.isEmpty(proveedor.idProveedor)) {
            missing.push(`Proveedor en fila ${idx + 1}`);
          }
        });
      }

      return missing;
    },
    validateStep2() {
      const missing = [];
      if (this.articulos.length < 1) {
        missing.push("Debes guardar al menos un artículo");
      }
      return missing;
    },
    async nextStep() {
      let missing = [];
      if (this.step === 1) {
        missing = this.validateStep1();
      } else if (this.step === 2) {
        missing = this.validateStep2();
      }

      if (missing.length > 0) {
        this.validationErrors = missing;
        this.showValidationSnackbar = true;
        return;
      }

      this.validationErrors = [];
      this.showValidationSnackbar = false;
      if (this.step === 1) {
        this.step = 2;
        return;
      }

      await this.guardarRecepcionLogistica();
    },
    async loadCatalogos() {
      await this.getArticuloTipos();
      await Promise.all([
        this.getAlmacenes(),
        this.getAreas(),
        this.getSubalmacenes(),
        this.getClientes(),
        this.getTurnos(),
        this.getProveedores(),
        this.getArticulos()
      ]);
    },
    getArticuloTipos() {
      return axios
        .get("/Articulos/ArticuloTipos")
        .then(response => {
          this.articulosTipos = response.data || [];
        })
        .catch(error => {
          console.log(error);
        });
    },
    getArticulos() {
      this.loadingArticulos = true;
      return axios
        .get("/Articulos/ArticulosNombres")
        .then(response => {
          this.articulosLista = response.data || [];
          const articulos = [];
          this.articulosTipos
            .slice()
            .sort((a, b) => a.idArticuloTipo - b.idArticuloTipo)
            .forEach((tipo, idx) => {
              if (idx > 0) articulos.push({ divider: true });
              articulos.push({ header: tipo.nombre });
              const filtrados = this.articulosLista
                .filter(articulo => articulo.idArticuloTipo === tipo.idArticuloTipo)
                .map(articulo => ({ ...articulo, group: tipo.nombre }));
              articulos.push(...filtrados);
            });
          this.articulosCatalogo = articulos;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingArticulos = false;
        });
    },
    getClientes() {
      this.loadingClientes = true;
      return axios
        .get("/Clientes")
        .then(response => {
          this.clientes = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingClientes = false;
        });
    },
    getTurnos() {
      this.loadingTurnos = true;
      return axios
        .get("/Turnos")
        .then(response => {
          this.turnos = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingTurnos = false;
        });
    },
    getProveedores() {
      this.loadingProveedores = true;
      return axios
        .get("/Proveedores")
        .then(response => {
          this.listaProveedores = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingProveedores = false;
        });
    },
    getAreas() {
      this.loadingAreas = true;
      return axios
        .get("/Areas")
        .then(response => {
          this.areas = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingAreas = false;
        });
    },
    getSubalmacenes() {
      this.loadingSubalmacenes = true;
      return axios
        .get("/Subalmacenes")
        .then(response => {
          this.subalmacenes = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingSubalmacenes = false;
        });
    },
    getAlmacenes() {
      this.loadingAlmacenes = true;
      return axios
        .get("/Almacenes")
        .then(response => {
          this.almacenes = (response.data || []).map(almacen => ({
            ...almacen,
            tipoAlmacen: this.normalizarTipoAlmacen(almacen.tipoAlmacen || almacen.TipoAlmacen)
          }));
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingAlmacenes = false;
        });
    },
    normalizarTipoAlmacen(tipo) {
      const tipoNormalizado = (tipo || "").toString().trim().toUpperCase();
      if (tipoNormalizado === "ADUANA") return "ADUANA";
      if (tipoNormalizado === "MERMA") return "MERMA";
      if (tipoNormalizado === "GENERAL" || tipoNormalizado === "INVENTARIO GENERAL" || tipoNormalizado === "INVENTARIO") return "GENERAL";
      return "";
    },
    syncTipoAlmacenFromSelection(idAlmacen) {
      if (!idAlmacen) {
        this.step1.tipoAlmacen = "";
        return;
      }

      const almacen = this.almacenes.find(item => String(item.idAlmacen) === String(idAlmacen));
      const tipoAlmacen = this.normalizarTipoAlmacen(
        almacen ? (almacen.tipoAlmacen || almacen.TipoAlmacen) : ""
      );

      this.step1.tipoAlmacen = tipoAlmacen || "GENERAL";
    },
    changeAlmacen() {
      this.step1.idSubalmacen = null;
      this.syncTipoAlmacenFromSelection(this.step1.idAlmacen);
    },
    almacenText({ codigo, nombre }) {
      return `[${codigo}] - ${nombre}`.trim();
    },
    areaText(area) {
      return `${area.area || area.nombre || area.nombreArea || `Área ${area.idArea}`}`.trim();
    },
    clienteText(cliente) {
      return `${cliente.nombre || cliente.razonSocial || cliente.cliente || `Cliente ${cliente.idCliente}`}`.trim();
    },
    turnoText(turno) {
      return `${turno.nombre || turno.turno || `Turno ${turno.idTurno}`}`.trim();
    },
    articuloLabel(articulo) {
      if (!articulo || !articulo.idArticulo) return "";
      return `[${articulo.codigo}] - ${articulo.nombre}`;
    },
    proveedorLabel(proveedor) {
      const codigo = proveedor.codigo ? `[${proveedor.codigo}] - ` : "";
      const nombre = proveedor.nombre || proveedor.proveedor || `Proveedor ${proveedor.idProveedor}`;
      return `${codigo}${nombre}`.trim();
    },
    subalmacenText({ clave, subalmacen }) {
      return `[${clave}] - ${subalmacen}`.trim();
    },
    crearPayloadRecepcionLogistica() {
      return {
        idAlmacen: this.step1.idAlmacen,
        tipoAlmacen: this.step1.tipoAlmacen,
        idArea: this.step1.idArea,
        idSubalmacen: this.step1.idSubalmacen,
        tipoMovimiento: this.step1.tipoMovimiento,
        fechaRecepcion: this.step1.fechaRecepcion,
        tipoCalidad: this.step1.tipoCalidad,
        fechaArribo: this.step1.fechaArribo,
        idCliente: this.step1.idCliente,
        tipoSolicitud: this.step1.tipoSolicitud,
        idTurno: this.step1.idTurno,
        numeroCortina: this.step1.numeroCortina,
        operador: this.step1.operador,
        montacarguista: this.step1.montacarguista,
        placas: this.step1.placas,
        sello: this.step1.sello,
        horaFin: this.step1.horaFin,
        lineaTransporte: this.step1.lineaTransporte,
        proveedores: this.proveedores
          .filter(proveedor => !this.isEmpty(proveedor.idProveedor))
          .map(proveedor => ({ idProveedor: proveedor.idProveedor })),
        articulos: this.articulos.map(articulo => ({
          idArticulo: articulo.idArticulo,
          descripcion: articulo.descripcion,
          etiquetas: (articulo.etiquetas || []).map(etiqueta => ({
            envases: this.normalizeMinOne(etiqueta.envases, true),
            volumen: this.normalizeMinOne(etiqueta.volumen),
            folio: etiqueta.folio || "",
            caducidad: etiqueta.caducidad || "",
            lote: etiqueta.lote || ""
          }))
        }))
      };
    },
    async guardarRecepcionLogistica() {
      this.savingRecepcion = true;
      try {
        const payload = this.crearPayloadRecepcionLogistica();
        await axios.post("/Inventario/CrearRecepcionLogistica", payload);
        this.close(1);
      } catch (error) {
        console.log(error);
        this.validationErrors = ["No se pudo guardar la recepción logística"];
        this.showValidationSnackbar = true;
      } finally {
        this.savingRecepcion = false;
      }
    },
    reset() {
      this.step = 1;
      this.validationErrors = [];
      this.showValidationSnackbar = false;
      this.savingRecepcion = false;
      this.step1 = createStep1Defaults();
      this.etiquetaDefault = createEtiquetaDefault();
      this.proveedores = [];
      this.artInput = { idArticulo: null, descripcionArticulo: '' };
      this.etiquetasBuffer = [];
      this.articulos = [];
      this.expandedArts = [];
    },
    close(status = 0) {
      this.validationErrors = [];
      this.showValidationSnackbar = false;
      this.savingRecepcion = false;
      this.$emit('change', status);
    },
    agregarProveedor() {
      this.uuidCounter++;
      this.proveedores.push({ ...this.proveedorDefault, uuid: this.uuidCounter });
    },
    eliminarProveedor(item) {
      const idx = this.proveedores.indexOf(item);
      if (idx > -1) this.proveedores.splice(idx, 1);
    },
    agregarEtiqueta() {
      this.uuidCounter++;
      this.etiquetasBuffer.push({ ...createEtiquetaDefault(), uuid: this.uuidCounter });
    },
    eliminarEtiquetaBuffer(item) {
      const idx = this.etiquetasBuffer.indexOf(item);
      if (idx > -1) this.etiquetasBuffer.splice(idx, 1);
    },
    agregarArticulo() {
      if(this.artInput.idArticulo) {
        const articulo = this.articulosLista.find(item => item.idArticulo === this.artInput.idArticulo);
        const etiquetas = this.etiquetasBuffer.map(etiqueta => ({
          ...etiqueta,
          envases: this.normalizeMinOne(etiqueta.envases, true),
          volumen: this.normalizeMinOne(etiqueta.volumen)
        }));
        this.uuidCounter++;
        this.articulos.push({
          uuid: this.uuidCounter,
          idArticulo: this.artInput.idArticulo,
          nombre: articulo ? this.articuloLabel(articulo) : '',
          descripcion: this.artInput.descripcionArticulo,
          etiquetas
        });
        this.artInput = { idArticulo: null, descripcionArticulo: '' };
        this.etiquetasBuffer = [];
      }
    },
    normalizeMinOne(value, integer = false) {
      let numero = Number(value);
      if (!Number.isFinite(numero) || numero < 1) numero = 1;
      if (integer) numero = Math.floor(numero);
      return numero;
    },
    ensureMinOne(item, field, integer = false) {
      item[field] = this.normalizeMinOne(item[field], integer);
    },
    articuloCantidad(articulo) {
      const etiquetas = (articulo.etiquetas || []).map(etiqueta => ({
        envases: this.normalizeMinOne(etiqueta.envases, true),
        volumen: this.normalizeMinOne(etiqueta.volumen),
      }));
      if (!etiquetas.length) return 0;
      const total = etiquetas.reduce((acum, etiqueta) => acum + (etiqueta.envases * etiqueta.volumen), 0);
      return Number.isInteger(total) ? total : Number(total.toFixed(2));
    },
    eliminarArticulo(item) {
      const idx = this.articulos.indexOf(item);
      if (idx > -1) this.articulos.splice(idx, 1);
    },
    eliminarEtiquetaDeArticulo(articulo, etiqueta) {
      const idx = articulo.etiquetas.indexOf(etiqueta);
      if (idx > -1) articulo.etiquetas.splice(idx, 1);
    }
  }
};
</script>
<style scoped>
@media print {
  .v-dialog { box-shadow: none; }
  .hide-print { display: none !important; }
}
</style>
